<!-- Service URL -->
<div class="form-group app-composite-widget clearfix">
    <label for="url" class="control-label app-label col-md-2">{{locale.LABEL_PROPERTY_URL}}</label>
    <div class="col-md-10">
        <input name="wm-webservice-sample-url" class="form-control app-textbox wide-input" id="url" type="text" [(ngModel)]="ws.webSocketUrl" (ngModelChange)="onUrlChange(ws.webSocketUrl)" ng-init="validateUrl(ws.webSocketUrl)"/>
        <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_REST_URL}}" class="wms wms-help"></i>
    </div>
</div>

<!-- Message Body -->
<div class="form-group app-composite-widget clearfix">
    <label class="control-label app-label col-md-2">{{locale.LABEL_WEB_SOCKET_REQUEST_BODY}}</label>
    <div class="col-md-10">
        <textarea class="form-control app-textarea" [(ngModel)]="ws.requestBody"
                  [disabled]="disableDialogActions"
                  title="Message to be sent to the target Web Socket endpoint"></textarea>
        <button name="wm-webservice-socket-connect" class="app-button button-primary test-button" title="{{locale.LABEL_PROJECTS_LIST_CONNECT}}"
                [disabled]="disableDialogActions || testDisabled" (click)="test()">{{locale.LABEL_TEST}}</button>
    </div>
</div>

<!-- Test Not Required Confirmation -->
<div class="form-group app-composite-widget clearfix">
    <label for="websocket-test-not-required" class="control-label app-label col-md-2">{{locale.LABEL_PROCEED_WITHOUT_TEST}}</label>
    <div class="col-md-10">
        <wms-toggle name="wm-webservice-websocket-test-not-required" id="websocket-test-not-required" hide-labels (onChange)="isTesting($event)" [model]="ws.testNotRequired"></wms-toggle>
        <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_WEBSOCKET_TEST_NOT_REQUIRED}}" class="wms wms-help"></i>
    </div>
</div>

<!-- Response Block -->
<div class="col-md-6 web-service-message">
    <h4>{{locale.LABEL_MESSAGES}}<i placement="left" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_WEBSOCKET_MESSAGES}}" class="wm-icon wms wms-help pull-right"></i></h4>
    <div class="form-group app-composite-widget clearfix response-text pre-scrollable">
        <table class="wm-table response-table">
            <tbody>
            <tr>
                <!--<th class="col-md-1"></th>-->
                <th colspan="2" class="col-md-12">{{locale.LABEL_SELECT_RESPONSE_FORMAT}}</th>
            </tr>
            <tr *ngFor="let message of ws.messages  index as i">
                <td class="text-center col-md-1"><input type="radio" [value]="message.message" (ngModelChange)="showResult($event)" [(ngModel)]="ws.responseBody"></td>
                <td class="col-md-11">
                    {{message?.message}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="col-md-6 web-service-message">
    <h4>{{locale.LABEL_SAMPLE_RESPONSE}}<i placement="left" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_WEBSOCKET_RESPONSE}}" class="wm-icon wms wms-help pull-right"></i></h4>
    <div class="form-group app-composite-widget clearfix response-text">
        <div class="wm-code-editor-container">
            <wms-editor name="wm-websocket-editor" [customClasses]="'wm-code-editor'" 
            [options]="editorOptions"  #codeEditor></wms-editor>
            <!-- <div class="wm-code-editor" ui-ace [(ngModel)]="ws.responseBody" handler="ws.editor" editor-type="{{ws.editorType}}"></div> -->
        </div>
    </div>
</div>
